export default __webpack_public_path__ + "static/media/no-arhiv-agency.33e4e209.svg";